// StoreCard 컴포넌트에서 사용하는 공통 타입 정의

export type StoreCoupon = {
  id: number;
  title: string;
  discountValue: number;
  minOrderPrice: number | null;
  endAt: string | null;
  maxUsageQuantity: number | null;
  usageCount: number | null;
  isExpired: boolean;
  isSoldOut: boolean;
} | null;

// 쿠폰이 유효한지 확인하는 유틸 함수 (타입 가드)
export const isCouponValid = (
  coupon: StoreCoupon
): coupon is NonNullable<StoreCoupon> => {
  return coupon !== null && !coupon.isExpired && !coupon.isSoldOut;
};

// 쿠폰 텍스트 포맷팅
export const formatCouponText = (discountValue: number): string => {
  return `선착순 쿠폰 ${discountValue.toLocaleString()}원✨`;
};
